import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import * as Styles from './Architects.styles';
import Container from '../Container/Container';
import Column from '../Column/Column';
import ContainerBG from '../ContainerBG/ContainerBG';

const Architects = () => {
  const data = useStaticQuery(graphql`
    {
      file(name: { eq: "architect-background" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, quality: 80)
        }
      }
    }
  `);

  return (
    <ContainerBG image={data.file.childImageSharp.gatsbyImageData}>
      <Styles.ArchitectContainer
        fluid
        flex
        height='100vh'
        bgColor='rgba(0,0,0,0.75)'
        bgBlend='multiply'>
        <Container flex alignItems='center' Height='100vh' wrap='true'>
          <Column column padding='32px' itemsCenter>
            <Styles.Header>
              <span>Szukasz</span>
              <span className='bold'>ARCHITEKTA?</span>
            </Styles.Header>
            <Styles.Content>
              Wspaniały pomysł!
              <br /> Codziennie obserwujemy spotkania architektów wnętrz z
              inwestorami i jesteśmy przekonane, że to najlepszy sposób na
              urządzenie domu. Z przyjemnością udostępniamy Państwu kontakty do
              znanych nam pracowni architektonicznych. Przykłady aranżacji z
              użyciem materiałów z naszej oferty znajdą Państwo również w
              zakładce „aranżacje”.
            </Styles.Content>
          </Column>
          <Column column padding='32px' itemsCenter>
            <Styles.Header>
              <span>Jesteś</span>
              <span className='bold'>ARCHITEKTEM?</span>
            </Styles.Header>
            <Styles.Content>
              Serdecznie zapraszamy do współpracy. Mamy klientów, to mogą być
              także Twoi klienci. Proponujemy pomoc w znajdowaniu materiałów,
              szkolenia, zapewniamy komplet wzorników oraz miejsce w zakładce
              „aranżacje” wraz linkiem do strony Twojej pracowni. Udostępniamy
              również miejsce do pracy i spotkań z inwestorem w specjalnie
              oddzielonej do tych celów strefie naszego salonu.
            </Styles.Content>
          </Column>
        </Container>
      </Styles.ArchitectContainer>
    </ContainerBG>
  );
};

export default Architects;
